export default __webpack_public_path__ + "static/ShareFormInSpanish-7e2e37c04fae191630303afd801ac53f.png";